// extracted by mini-css-extract-plugin
module.exports = {"background":"CBLoadingCircle_background__3kMKw","loader":"CBLoadingCircle_loader__J0oqf","spin":"CBLoadingCircle_spin__2Rc8r"};